import { render, staticRenderFns } from "./emailElementViewer.vue?vue&type=template&id=04ef3e62&scoped=true&"
import script from "./emailElementViewer.vue?vue&type=script&lang=js&"
export * from "./emailElementViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef3e62",
  null
  
)

export default component.exports